import {cachifyPromise} from 'cachify-promise';
import {api} from '../../config';
import {MpApiMeResponse} from '../store/models/user/types';
import {SalesforceTokensResponse} from '../store/models/salesforce/types';
import {httpDeleteRes, httpGetJson, httpPostJson} from './http';

export function composeFetchUser(baseUrl = '') {
  const fetchUser = () =>
    httpGetJson<MpApiMeResponse>({
      path: `${baseUrl}${api.mpApiClient}/me`,
    });
  return cachifyPromise(fetchUser);
}

export const fetchUser = composeFetchUser();

export function composeRequestSalesforceTokens(baseUrl = '') {
  const requestSalesforceTokens = () =>
    httpPostJson<SalesforceTokensResponse>({
      path: `${baseUrl}${api.mpApiClient}/salesforce/chat-token`,
    });
  return cachifyPromise(requestSalesforceTokens, {ttl: 300000 /* 5 min */});
}

export const requestSalesforceTokens = composeRequestSalesforceTokens();

export function composeRequestAccountDeletion(baseUrl = '') {
  return () =>
    httpDeleteRes({
      path: `${baseUrl}${api.mpApiClient}/me`,
    });
}

export const requestDeletion = composeRequestAccountDeletion();
